import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AppDispatch, RootState } from "../../../../redux-stores/store";
import { setSelectedSocialPost } from "../../../../redux-stores/slices/layoutSlice";
import { CollaborationPost } from "../../../../types/collaborations/CollaborationTypes";
import { formatNumber, toValidNumber } from "../../../../utils/helpers";
import "./collaborationContentV2.scss";

const EyeIcon = () => (
    <svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style={{ display: "block" }} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.00325 6C7.47282 6 6.96411 6.21071 6.58904 6.58579C6.21397 6.96086 6.00325 7.46957 6.00325 8C6.00325 8.53043 6.21397 9.03914 6.58904 9.41421C6.96411 9.78929 7.47282 10 8.00325 10C8.53369 10 9.0424 9.78929 9.41747 9.41421C9.79254 9.03914 10.0033 8.53043 10.0033 8C10.0033 7.46957 9.79254 6.96086 9.41747 6.58579C9.0424 6.21071 8.53369 6 8.00325 6ZM8.00325 11.3333C7.1192 11.3333 6.27135 10.9821 5.64623 10.357C5.02111 9.7319 4.66992 8.88406 4.66992 8C4.66992 7.11595 5.02111 6.2681 5.64623 5.64298C6.27135 5.01786 7.1192 4.66667 8.00325 4.66667C8.88731 4.66667 9.73516 5.01786 10.3603 5.64298C10.9854 6.2681 11.3366 7.11595 11.3366 8C11.3366 8.88406 10.9854 9.7319 10.3603 10.357C9.73516 10.9821 8.88731 11.3333 8.00325 11.3333ZM8.00325 3C4.66992 3 1.82326 5.07333 0.669922 8C1.82326 10.9267 4.66992 13 8.00325 13C11.3366 13 14.1833 10.9267 15.3366 8C14.1833 5.07333 11.3366 3 8.00325 3Z" fill="currentColor" fillOpacity="0.7" />
    </svg>
);

const LikeIcon = () => (
    <svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style={{ display: "block" }} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.59907 3.49772C3.27563 2.82136 4.19312 2.44141 5.14978 2.44141C6.10643 2.44141 7.02392 2.82136 7.70048 3.49772C7.83277 3.62952 8.00305 3.79355 8.21134 3.98982C8.41915 3.79355 8.5892 3.62952 8.72148 3.49772C9.39521 2.82715 10.3063 2.44957 11.2569 2.44703C12.2075 2.44448 13.1206 2.81718 13.7979 3.48412C14.4752 4.15107 14.8619 5.05836 14.8741 6.00884C14.8862 6.95932 14.5227 7.87618 13.8626 8.56016L8.72076 13.702C8.58545 13.8372 8.40195 13.9132 8.21062 13.9132C8.01929 13.9132 7.83579 13.8372 7.70048 13.702L2.55867 8.56088C1.89919 7.88074 1.5337 6.9685 1.54113 6.02117C1.54855 5.07383 1.92902 4.16743 2.59907 3.49772Z" fill="currentColor" fillOpacity="0.7" />
    </svg>
);

const CommentIcon = () => (
    <svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style={{ display: "block" }} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M8.00261 1.3327C4.32061 1.3327 1.33594 4.31737 1.33594 7.99937C1.33537 8.98162 1.55187 9.95186 1.96994 10.8407L1.34994 13.8654C1.32786 13.9734 1.33291 14.0851 1.36463 14.1907C1.39635 14.2963 1.45375 14.3923 1.5317 14.4703C1.60964 14.5482 1.70569 14.6056 1.81126 14.6373C1.91683 14.6691 2.02861 14.6741 2.13661 14.652L5.16127 14.032C6.02394 14.4387 6.98794 14.6654 8.00261 14.6654C11.6846 14.6654 14.6693 11.6814 14.6693 7.9987C14.6693 4.31736 11.6846 1.33203 8.00261 1.33203" fill="currentColor" fillOpacity="0.7" />
    </svg>
);

const SendIcon = () => (
    <svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style={{ display: "block" }} viewBox="0 0 13.3333 14.2239" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.2634 1.5241C13.5905 0.61922 12.7136 -0.257645 11.8088 0.0702328L0.749503 4.06989C-0.158408 4.39852 -0.268206 5.63734 0.567012 6.12121L4.09719 8.16496L7.24951 5.01263C7.39233 4.8747 7.5836 4.79837 7.78215 4.8001C7.98069 4.80183 8.17061 4.88146 8.311 5.02186C8.4514 5.16225 8.53104 5.35217 8.53276 5.55072C8.53449 5.74926 8.45816 5.94053 8.32023 6.08335L5.1679 9.23567L7.21241 12.7658C7.69552 13.6011 8.93434 13.4905 9.26297 12.5834L13.2634 1.5241Z" fill="currentColor" fillOpacity="0.7" />
    </svg>
);

type CollabStatus = "approved" | "pending" | "rejected" | string;

const getRibbonVars = (status: CollabStatus) => {
    if (status === "approved") return { bg: "var(--status-approved-bg)", border: "var(--status-approved-border)", label: "Approved" };
    if (status === "pending") return { bg: "var(--status-pending-bg)", border: "var(--status-pending-border)", label: "Pending" };
    if (status === "rejected") return { bg: "var(--status-rejected-bg)", border: "var(--status-rejected-border)", label: "Rejected" };
    return { bg: "var(--muted)", border: "var(--dark-gray)", label: status || "Status" };
};

const CollaborationContentV2: React.FC<{ collaborationPosts: CollaborationPost[] }> = ({ collaborationPosts }) => {
    const dispatch: AppDispatch = useDispatch();
    const { campaignId } = useParams();
    const collaboration = useSelector((state: RootState) => state.collaborationDetails.collaborations[campaignId!]?.collaborationData);
    const socialAccount = collaboration?.collaboration?.social_account;

    const reels = useMemo(() => collaborationPosts.filter((cp) => cp.social_post.type === "REELS"), [collaborationPosts]);
    const posts = useMemo(() => collaborationPosts.filter((cp) => cp.social_post.type === "FEED"), [collaborationPosts]);
    const stories = useMemo(() => collaborationPosts.filter((cp) => cp.social_post.type === "STORY"), [collaborationPosts]);
    const videos = useMemo(() => collaborationPosts.filter((cp) => cp.social_post.type === "VIDEO"), [collaborationPosts]);

    const all = useMemo(() => {
        return [...collaborationPosts];
    }, [collaborationPosts]);

    const [expanded, setExpanded] = useState<Record<string, boolean>>({});

    const toggleExpanded = (id: string) => {
        setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    if (!all.length) {
        return (
            <div className="collab-content-v2 d-flex justify-content-center align-items-center py-5 my-5">
                <span className="text-muted fs-14 text-center">No content posted yet</span>
            </div>
        );
    }

    return (
        <div className="collab-content-v2">
            {/* Keeping these computed arrays for future filters */}
            <span className="d-none" aria-hidden>
                {reels.length + posts.length + stories.length + videos.length}
            </span>
            {all.map((post) => {
                const id = post.social_post.uuid;
                const status = (post.status as CollabStatus) || "pending";
                const ribbon = getRibbonVars(status);
                const isApproved = status === "approved";

                const caption =
                    post.social_post?.platform === "ig"
                        ? post.social_post?.ig?.caption || ""
                        : post.social_post?.platform === "yt"
                            ? post.social_post?.yt?.title || ""
                            : "";

                const short = caption.length > 68 ? `${caption.slice(0, 68).trim()}..` : caption;
                const isLong = caption.length > 68;
                const showFull = !!expanded[id];

                const views = formatNumber(toValidNumber(post.social_post.views_count));
                const likes = formatNumber(toValidNumber(post.social_post.like_count));
                const comments = formatNumber(toValidNumber(post.social_post.comments_count));
                const shares = formatNumber(toValidNumber((post.social_post as any).shares_count));

                return (
                    <div className="collab-content-card-v2" key={id}>
                        <button
                            type="button"
                            className="collab-content-thumb-v2"
                            style={{ backgroundImage: `url(${post.social_post.thumbnail_url})` }}
                            onClick={() => dispatch(setSelectedSocialPost({ socialAccountId: socialAccount?.uuid, socialPostId: post.social_post.uuid }))}
                            aria-label="Open post"
                        >
                            <span className="collab-content-thumb__ig" aria-hidden />
                        </button>

                        <div className="collab-content-ribbon-v2" style={{ background: ribbon.bg, borderColor: ribbon.border }}>
                            <span>{ribbon.label}</span>
                        </div>

                        <div className="collab-content-body-v2">
                            {
                                Boolean(caption) && (
                                    <p className="collab-content-caption-v2">
                                        <span>{showFull ? caption : short}</span>
                                        {isLong ? (
                                            <button type="button" className="collab-content-readmore-v2" onClick={() => toggleExpanded(id)}>
                                                Read {showFull ? "Less" : "More"}
                                            </button>
                                        ) : null}
                                    </p>)
                            }

                            <p className="collab-content-date-v2">{(post as any).posted_on ?? post.social_post?.posted_on ?? null}</p>
                            <>
                                <div className="collab-content-metrics-v2">
                                    <div className="collab-content-metric-v2">
                                        <span className="collab-content-metric-icon-v2">
                                            <EyeIcon />
                                        </span>
                                        <span className="collab-content-metric-value-v2">{views || "0"}</span>
                                    </div>
                                    <div className="collab-content-metric-v2">
                                        <span className="collab-content-metric-icon-v2">
                                            <LikeIcon />
                                        </span>
                                        <span className="collab-content-metric-value-v2">{likes || "0"}</span>
                                    </div>
                                    <div className="collab-content-metric-v2">
                                        <span className="collab-content-metric-icon-v2">
                                            <CommentIcon />
                                        </span>
                                        <span className="collab-content-metric-value-v2">{comments || "0"}</span>
                                    </div>
                                    <div className="collab-content-metric-v2">
                                        <span className="collab-content-metric-icon-v2">
                                            <SendIcon />
                                        </span>
                                        <span className="collab-content-metric-value-v2">{shares || "0"}</span>
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default CollaborationContentV2;

